import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";
import { FaDownload, FaPaperPlane } from "react-icons/fa";
import PageLayout from "./PageLayout";
import { getAssignedRequestApi, updateRemarksApi } from "src/network/api";
import { toast } from "react-toastify";
import { useAppSelector } from "src/state/store/store";

const ManageReviewer = () => {
  const [papers, setPapers] = useState([]);
  const [remarks, setRemarks] = useState({});
  const id = useAppSelector((state) => state.auth.user.id);

  const fetchPapers = async () => {
    try {
      const response = await getAssignedRequestApi();
      if (response.status === 200 && response.data.status === 200) {
        setPapers(response.data.data);
        console.log(response.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  useEffect(() => {
    fetchPapers();
  }, []);

  const handleRemarkChange = (id, value) => {
    setPapers((prev) =>
      prev.map((paper) =>
        paper.pr_id === id ? { ...paper, reviewer_remarks: value } : paper
      )
    );
  };

  const handleUpdateRemark = async (id) => {
    const formdata = new FormData();
    const paper = papers.find((paper) => paper.pr_id === id);
    formdata.append("remarks", paper?.reviewer_remarks || "");

    try {
      const response = await updateRemarksApi(id, formdata);
      if (response?.data?.status === 200 && response?.status === 200) {
        toast.success(response?.data?.message);
      } else {
        toast.error("Failed to update remark.");
      }
    } catch (e) {
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  return (
    <PageLayout>
      <div className="mt-5 mb-7 container-fluid">
        <Row className="justify-content-center">
          <Col lg="12">
            <Card className="shadow">
              <CardHeader className="bg-primary text-white text-center">
                <h3 className="mb-0 text-white">Assigned Papers</h3>
              </CardHeader>
              <CardBody>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th>Paper Title</th>
                      <th>Subject</th>
                      <th>Journal</th>
                      <th>Paper Description</th>
                      <th>Download Paper</th>
                      <th>Remark</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {papers?.length > 0 ? (
                      papers.map((paper) => (
                        <tr key={paper.id}>
                          <td>{paper.paper_title}</td>
                          <td>{paper.subjects}</td>
                          <td>{paper.journal_name}</td>
                          <td>{paper.abstract}</td>
                          <td>
                            <a
                              target="_blank"
                              className="btn btn-primary btn-sm"
                              color="info"
                              href={paper.file}
                              download
                            >
                              <FaDownload /> Download
                            </a>
                          </td>
                          <td>
                            <Input
                              style={{ minWidth: 300 }}
                              type="textarea"
                              value={paper.reviewer_remarks}
                              onChange={(e) =>
                                handleRemarkChange(paper.pr_id, e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleUpdateRemark(paper.pr_id)}
                            >
                              <FaPaperPlane /> Update Remark
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </PageLayout>
  );
};

export default ManageReviewer;
